import { connect } from 'react-redux';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import { actions } from '../../../actions/telephony';
import { ExternalCallerIdModal as ExternalCallerIdModalComp } from '../../../components/sections/telephony/modals/externalCallerIdModal';
export const { telephonyShowExternalCallerIdModal, telephonyHideExternalCallerIdModal, telephonyVerifyExternalCallerId, } = actions;
const mapStateToProps = (state) => {
    return {
        meta: state.settings.telephony.meta,
        ui: state.settings.telephony.ui,
        verifyPhoneNumber: state.settings.telephony.verifyPhoneNumber,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        showExternalCallerIDModal: bindActionToPromise(dispatch, telephonyShowExternalCallerIdModal),
        hideExternalCallerIdModal: bindActionToPromise(dispatch, telephonyHideExternalCallerIdModal),
        verifyExternalCallerId: bindActionToPromise(dispatch, telephonyVerifyExternalCallerId),
    };
};
export const ExternalCallerIdModal = connect(mapStateToProps, mapDispatchToProps)(ExternalCallerIdModalComp);
